import { getPageViewProps } from "@/components/vendor/Analytics/pageViewPropsSnippet";
import { SEGMENT_ANONYMOUS_ID_COOKIE } from "@/constants/cookies";
import { readCookie } from "@/utils/cookies";
import { currentTheme } from "@/utils/theming";

/**
 * Pseudo–"Loaded a Page" fields (same shape as former dataLayer push).
 * Used for first-party gtag('event','page_view') params (mimic Segment→GTM).
 *
 * @see https://nutrafol.atlassian.net/browse/NT2-30510
 */
export type LoadedAPagePayload = {
  OnetrustActiveGroups: string | null;
  OptanonActiveGroups: string | null;
  nutrafolBrandTag: "men" | "master";
  path: string;
  referrer: string;
  search: string;
  title: string;
  url: string;
  business_line: string | null;
  page_type: string | null;
  page_referrer: string;
  product_line: string | null;
  product_gender: string | null;
  page_detail: string | null;
  page_template: string | null;
  page_intent: string | null;
  marketing_owner: string | null;
  marketing_type: string | null;
  userAgent: string;
  name: string;
  userId: string | null;
  segmentAnonymousId: string | null;
};

export function buildLoadedAPagePayload(): LoadedAPagePayload {
  const pathname = window.location.pathname;
  const props = getPageViewProps(pathname, document.referrer || "");

  const name = document.title?.split(" | ")[0] || "";
  const otGroups =
    typeof window.OnetrustActiveGroups === "string" ? window.OnetrustActiveGroups : "";
  const optanonGroups =
    typeof window.OptanonActiveGroups === "string" ? window.OptanonActiveGroups : otGroups;

  return {
    OnetrustActiveGroups: otGroups || null,
    OptanonActiveGroups: optanonGroups || null,
    nutrafolBrandTag: currentTheme(pathname) === "men" ? "men" : "master",
    path: pathname,
    referrer: document.referrer || "",
    search: window.location.search || "",
    title: document.title || "",
    url: window.location.href,
    business_line: props.business_line ?? null,
    page_type: props.page_type ?? null,
    page_referrer: document.referrer || "",
    product_line: props.product_line ?? null,
    product_gender: props.product_gender ?? null,
    page_detail: props.page_detail ?? null,
    page_template: props.page_template ?? null,
    page_intent: props.page_intent ?? null,
    marketing_owner: props.marketing_owner ?? null,
    marketing_type: props.marketing_type ?? null,
    userAgent: navigator.userAgent,
    name,
    userId: null,
    segmentAnonymousId: readCookie(SEGMENT_ANONYMOUS_ID_COOKIE),
  };
}
